<script>
import Changes from "@wielink-application/shared/js/mixins/changes";
import formElements from "@wielink-application/shared/js/mixins/formElements";
import Card from "@/pages/components/card.vue";
import {useForm} from "@inertiajs/vue3";

export default {
	mixins: [Changes, formElements],
	components: {Card},
	data() {
		return {
			productTesterType: {},
			form: useForm({
				name: '',
				code: '',
				external_product_id: '',
				appointment_duration: '',
			})
		}
	},

	methods: {
		setProductTesterType(productTesterType) {
			this.productTesterType = productTesterType;
			this.form.defaults(productTesterType);
			this.form.reset();
		}
	}
}
</script>

<template>
	<div class="row gap-4">
		<div class="col-xl-6">
			<Card class="h-100">
				<h2 class="card-title">Details</h2>

				<Input
					:form="form"
					v-model="form.external_product_id"
					name="external_product_id"
					label="Artikelnummer King"
				/>

				<Input
					:form="form"
					v-model="form.name"
					name="name"
					label="Type"
					:required="true"
				/>

				<Input
					:form="form"
					v-model="form.code"
					name="code"
					label="Afkorting"
				/>

				<Input
					groupClasses="mb-0"
					:form="form"
					v-model="form.appointment_duration"
					name="appointment_duration"
					label="Duur van inspectie"
					type="time"
				/>
			</Card>
		</div>
	</div>
</template>
